/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { ExperienceEntity } from './experience-entity';
export class CandidateOpportunityExperienceEntity extends Entity {
  candidateOpportunityId: string = '';
  createdAt: string | null = null;
  experience: ExperienceEntity | null = null;
  experienceId: string = '';
  experienceVisible: boolean | null = null;
  highlighted: boolean = false;
  id: string = '';
  submissionDescription: string | null = null;
  updatedAt: string | null = null;
  static override key = 'CandidateOpportunityExperience';
  static override get schema() {
    return {
      experience: ExperienceEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateOpportunityExperience' in input
    ) {
      const { CandidateOpportunityExperience: wrapped, ...rest } = input as {
        CandidateOpportunityExperience: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}